import React from 'react';

export const ShieldSvg: React.FC<React.SVGProps<SVGSVGElement>> = () => (
  <svg
    width="437"
    height="491"
    viewBox="0 0 437 491"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M218.23 0.894158H218.206L218.045 0.901016L218.04 0.901055C215.738 0.996673 213.345 1.46117 211.205 2.37063L211.15 2.39397L11.7783 90.6303L11.7668 90.6354C5.13587 93.5825 0.676405 100.399 0.617452 107.646L0.617188 107.679V107.711C0.617188 230.939 27.7403 312.161 68.4093 369.725C108.968 427.122 161.884 459.566 209.009 488.103L209.018 488.109L209.028 488.115C215.166 491.809 222.672 491.762 228.498 488.049C275.603 459.52 328.468 427.078 369.006 369.727C409.686 312.171 436.804 230.949 436.804 107.711V107.658L436.803 107.605C436.708 100.42 432.314 93.5971 425.661 90.6368L425.654 90.6335L226.362 2.43265L226.345 2.42474C223.419 1.11808 220.598 0.816424 218.23 0.894158ZM218.708 40.2001L38.5686 119.797C40.3302 230.101 64.8693 299.755 98.9855 348.032C132.058 394.833 174.923 423.27 218.708 450.009C262.487 423.275 305.356 394.829 338.431 348.032C372.551 299.757 397.087 230.101 398.847 119.797L218.708 40.2001ZM294.462 173.024C300.9 166.322 311.339 166.318 317.768 173.024C324.205 179.729 324.205 190.603 317.768 197.304L201.223 318.71C198.006 322.065 193.784 323.74 189.566 323.74C185.348 323.74 181.13 322.061 177.913 318.71L119.641 258.01C113.203 251.304 113.203 240.434 119.641 233.728C126.078 227.023 136.513 227.023 142.95 233.728L189.57 282.291L294.462 173.024Z"
      fill="currentColor"
    />
  </svg>
);

export default ShieldSvg;
